import { useRealtime } from '../contexts/RealtimeContext';

// Contagem de leads não visualizados, atualizada em tempo real pelo RealtimeContext (sem polling).
export const useUnviewedLeadsCount = () => {
  const { unviewedLeads, markLeadsViewed, markAllLeadsViewed, refreshCounts } = useRealtime();

  return {
    count: unviewedLeads,
    loading: false,
    refresh: refreshCounts,
    markAsViewed: markLeadsViewed,
    markAllAsViewed: markAllLeadsViewed,
  };
};
